"use strict";
/// <reference path="irep.js"/>

IREP.quickpoll = (function () {
    var submitButton;
    var sidebarH2;
    var $BandOrNot;
        if (typeof $band === 'undefined') { 
            var $BandOrNot = $("#quickPoll").parent(); 
        }
        else {$BandOrNot= $band }
    var init = function (options) {

        var results_template;
        results_template = Handlebars.compile($("#results-template").html());
        var qpData = {};
        qpData.Code = options.quizCode;
        qpData.CultureCode = IREP.options.user.cultureCode;
        qpData.CountryCode = IREP.options.user.countryCode;
        qpData.SQuestions = options.hfQuestions;
        qpData.StoreChainId = options.storeChainId; 
        submitButton = options.submitButton;
        var messageRetrievingResults = options.messageRetrievingResults;

        //get results if user already took poll
        IREP.callApi("quiz/quickpollsubmit", "POST", qpData).done(function (data) { 
            if (data.qpr != null) {
                var html = results_template(data.qpr); 
                $(options.element).find('.results').html(html);
                //$("#results").html(html);
                if (data.qpr.length > 5) {
                    $(options.element).find("#quickPoll").css("margin-top", "-25px");
                }
            } 
        });

        $(options.submitButton).click(function () {
            if (typeof $(options.element).find("input:checked").val() != "undefined") {//force them to make a selection to submit

                qpData.AnswerCode = ""; //get which radio buttons are checked
                for (var i = 0; i < $(options.element).find("input:checked").length; i++) {
                    if (qpData.AnswerCode != "") qpData.AnswerCode += "|";
                    qpData.AnswerCode += $(options.element).find("input:checked")[i].value;
                }

                qpData.AnswerText = "";
                qpData.ActivityTime = options.hfTimeStamp;
                $(options.submitButton).css("display", "none"); //hide submit button
                $(options.divSubmit).html(messageRetrievingResults);

                IREP.callApi("quiz/quickpollsubmit", "POST", qpData).done(function (data) {
                    if (data != null) {
                        if (data.qpr.length > 5) {
                            $(options.element).css("margin-top", "-25px");
                        }
                        var html = results_template(data.qpr);
                        $(options.element).find(".results").html(html);

                        formatAndAnimateResponses($(options.element));
                        $(options.divSubmit).html(""); //clear retrieving results messagse
                        $(options.element).find(".AnswerText").css("display", "none"); //hide the poll
                    }
                    else { }
                });
            }
            return false;
        });
    };
    var animateQuickPoll = function ($band) {//fade in options 1 at a time 
        if (typeof $band === 'undefined') {
            var $BandOrNot = $("#quickPoll").parent(); 
        }
        else { $BandOrNot = $band }
            var band1 = new TimelineMax();
            band1
            .to($BandOrNot.find("#quickPoll"), .25, { opacity: 1 })
            .from($BandOrNot.find(".QuestionText"), .25, { opacity: 0, marginLeft: "+=10px" })

            $BandOrNot.find('li', 'ul.AnswerText').each(function () {
                band1.from($(this), .25, { opacity: 0, marginLeft: "+=10px" })
            });

            band1.from($BandOrNot.find(".Submit").parent(), .25, { opacity: 0, marginLeft: "-=10px" })


            //var ctr = 1;
            //$('li', 'ul.AnswerText').each(function () {
            //    if (ctr >= 2)
            //        $(this).hide().delay(ctr * 200).fadeIn(1000); //delay subsequent radio options
            //    else
            //        $(this).hide().fadeIn(1000);
            //    ctr++;
            //});
            //$(options.submitButton).hide().delay(ctr * 200).fadeIn(1000);}
        } 

    var formatAndAnimateResponses = function ($band) {
	// Content sometimes isn't ready when linking straight to quickpoll which fires this function

        if (typeof $band === 'undefined') {
            var $BandOrNot = $("#quickPoll").parent(); 
        }
        else { $BandOrNot = $band }

            if (($BandOrNot.find("tr.item").size() == 0) && (($BandOrNot.find(".InputButton").size() == 0))) {
                setTimeout(function () {
                    formatAndAnimateResponses($BandOrNot);
                }, 500);
                return;
            }
       

        animateQuickPoll($BandOrNot);//animate questions

        var band1 = new TimelineMax();

        //band1.from($(this).find("td.cell1"), 1.5, { opacity: 0, marginLeft: "-=10px" })
        //band1.from($(this).find("td.cell2"), 1.5, { opacity: 0, marginLeft: "-=10px" })

        //if user already responsed to poll, animate through results
        $BandOrNot.find("tr.item").each(function () { //iterate through each answer and set percentage of answers answered
            var answerPercent = $(this).find("span.value").html();
            var answerPercentFormatted;
            if (answerPercent.indexOf("%") != -1) //already formatted
            {
                answerPercentFormatted = answerPercent;
                answerPercent = answerPercent.replace("%", "");
                answerPercent = answerPercent / 100;
            }
            else {
                answerPercentFormatted = (answerPercent) + "%";
            }

            $(this).find("td.cell1").animate({ width: ((answerPercent).toString() + "%").replace(",", ".") }, 1000);

            $(this).find("span.value").html(answerPercentFormatted);

            $(this).find("td.cell2").css("width", ((100 - (answerPercent)).toString() + "%").replace(",", "."));

        });

        $BandOrNot.find("#ResponseText").each(function () {
            band1
                .to($BandOrNot.find("#quickPoll"), 1, { opacity: 1 })
                .from($BandOrNot.find("td"), 1, { opacity: 0 })
        });
    
    }

    return {
        init: init,
        formatAndAnimateResponses: formatAndAnimateResponses
    };
})();

